import {
  BellIcon,
  CalendarIcon,
  ClockIcon,
  HomeIcon,
  SettingsIcon,
  UsersIcon,
} from "../ui/icons";

/**
 * The device-scoped navigation. `page` matches the :page segment of
 * /device/:deviceId/:page, which is what side-nav and the tab bar match on.
 *
 * `tab: true` marks the items that appear in the phone tab bar; everything
 * else lives behind "More".
 */
export const DEVICE_NAV = [
  { page: "dashboard", label: "Today", short: "Today", Icon: HomeIcon, tab: true },
  { page: "schedule", label: "Medication Schedule", short: "Schedule", Icon: CalendarIcon, tab: true },
  { page: "notifications", label: "Notifications", short: "Alerts", Icon: BellIcon, tab: true },
  { page: "adherence", label: "Adherence History", short: "History", Icon: ClockIcon },
  { page: "network", label: "Family & Reports", short: "Family", Icon: UsersIcon },
  { page: "settings", label: "Device Settings", short: "Settings", Icon: SettingsIcon },
];

/** Sidebar items above the divider; Device Settings sits in the footer. */
export const PRIMARY_NAV = DEVICE_NAV.filter((item) => item.page !== "settings");
export const FOOTER_NAV = DEVICE_NAV.filter((item) => item.page === "settings");

/** Phone tab bar: three items plus a "More" trigger added by the component. */
export const TAB_NAV = DEVICE_NAV.filter((item) => item.tab);
export const MORE_NAV = DEVICE_NAV.filter((item) => !item.tab);

export const pageTitle = (page) => DEVICE_NAV.find((item) => item.page === page)?.label || "";
